//Componentes generales
import React, { useState, useMemo, useContext } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRReqsSectors";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos
import "./ReqSectorList.css";

/*
    Componente encargado de la vista de los sectores de requerimientos disponibles.
    Donde sectores de requerimientos es la lista de sectores de requerimientos disponibles recuperados del context.
*/
function ReqSectorList({ reqsSectors = [] }) {
  //state de filtro.
  const [filter, setFilter] = useState("");

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  /*
    Manejador ante cambios en filtro.
    Donde data es el texto ingresado por el usuario.
    */
  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  return (
    <div>
      <div style={{ marginLeft: "-150px" }}>
        <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
      </div>
      <div
        className="container-req-sector-list"
        style={{ height: height - 200, overflowY: "scroll" }}
      >
        {reqsSectors
          .filter(
            (rS) =>
              rS.codSem.toLowerCase().includes(filter.toLowerCase()) ||
              rS.descrp.toLowerCase().includes(filter.toLowerCase())
          )
          .map((rS, index, style) => (
            <RenderRow
              key={index}
              index={index}
              style={{ style }}
              reqsSectors={reqsSectors}
              filter={filter}
            />
          ))}
      </div>
    </div>
  );
}

export default ReqSectorList;
